import { render, staticRenderFns } from "./textCom.vue?vue&type=template&id=06f81448"
import script from "./textCom.vue?vue&type=script&lang=js"
export * from "./textCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports